import styled from 'styled-components';
import { media, styles } from 'theme';

export const SearchTypeList = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  flex-wrap: nowrap;
  overflow-x: auto;

  >*: nth-child(n + 1) {
    margin-right: 8px;
  }
`;

export const TopicTag = styled.div`
  padding: 5px 12px;
  background: ${props =>
    props.isHighlighted
      ? props.theme.colors.seedlyBlue
      : props.theme.colors.neutral2};
  border-radius: 4px;
  cursor: pointer;
`;

export const TopicName = styled.p`
  display: flex;
  font-size: 14px;
  font-weight: ${props => (props.isHighlighted ? 'bold' : 'normal')};
  color: ${props =>
    props.isHighlighted ? 'white' : props.theme.colors.neutral5};
  white-space: nowrap;
`;

export const TopSection = styled.div`
  background-color: white;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const BottomSection = styled.div`
  background-color: ${props => props.theme.colors.neutral2};
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 1024px;

  ${media.largeAndDown`
    width: 100%;
  `}
`;

export const ProductListWrapper = styled.div`
  ${media.largeAndDown`
    padding: 0 18px;
  `}

  > ul {
    justify-content: space-between;
    flex-direction: inherit;

    > li {
      width: calc((100% - 10px) / 2);
      margin-left: 10px !important;

      &:nth-child(2n + 1) {
        margin-left: 0 !important;
      }

      ${media.largeAndDown`
        width: 100%;
        margin-left: 0px !important;
      `}
    }
  }
`;

export const ContentWrapper = styled.div`
  width: ${styles.desktopContentWidth};

  ${media.largeAndDown`
    width: 100%;
  `}
`;

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

export const InputContainer = styled.div`
  position: relative;
  align-items: center;
  width: 660px;
  margin-bottom: 32px;

  ${media.largeAndDown`
     width: calc(100% - 40px);
     margin-left: 20px;
     margin-bottom: 20px;
  `}
`;

export const Input = styled.input`
  border: none;
  border-bottom: 1px solid ${props => props.theme.colors.neutral4};
  font-size: 28px;
  font-weight: bold;
  font-family: Open Sans;
  width: 100%;
  padding: 12px 8px;
  &:focus {
    border-bottom: 1px solid ${props => props.theme.colors.seedlyBlue};
    outline: none;
  }

  ${media.smallAndDown`
    font-size: 24px;
  `}
  ::placeholder {
    color: #9aa1b3;
  }
`;

export const ClearButton = styled.button`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  margin-right: 6px;

  svg {
    fill: ${props => props.theme.colors.neutral5};
    stroke: #ffffff;
  }
`;

export const SearchResultContainer = styled.div`
  width: 660px;

  ${media.largeAndDown`
     width: 100%;
  `}
`;
